class Technician {
    constructor (
        id,
        name,
        cpfCnpj,
        phone,
        cityID,
        address,
        active,
        cityName
    ) {
        this.id = id,
        this.name = name,
        this.cpfCnpj = cpfCnpj,
        this.phone = phone,
        this.cityID = cityID,
        this.address = address,
        this.active = active,
        this.cityName = cityName
    }
}

export const technicianDefault = () => {
    const technician = {
        id: 0,
        name: "",
        cpfCnpj: "",
        phone: "",
        cityID: 0,
        address: "",
        active: true,
        cityName: ""
    }
    return technician
}

export default Technician